import React from 'react';

const GridItem = ({id, content, shapeClass, setLearnMore}) => {

  const gridClasses = `ssc__grid-item ssc__player__grid-item-${shapeClass} ssc__player__grid-item-${id}`;

  const handleClick = (content) => {
    if (content.link) {
      window.open(content.link, '_blank');
    } else {
      setLearnMore(content);
    }
  }

  return (
    <div className={gridClasses} onClick={() => handleClick(content)}>
      <div className="ssc__grid-item__inner">
        <img className="ssc__grid-item__icon" src={content.icon} alt={content.title} />
        <h3>
        	{content.subtitle &&
        		<span>{content.subtitle}</span>
        	}
        	<span>{content.title}</span>
        </h3>
      </div>
    </div>
  );

}

export default GridItem;


// WEBPACK FOOTER //
// ./src/components/GridItem/GridItem.js